let sessionHash = '';

if (window && window.sessionStorage) {
  sessionHash = window.sessionStorage.getItem('session') || ''
}

const get = () => sessionHash
const unset = () => {
  sessionHash = ''
  window.sessionStorage.removeItem('session')
}
const set = (hash) => {
  sessionHash = hash
  window.sessionStorage.setItem('session', hash)
  return hash
}

export default {
  get,
  set,
  unset
}
